<template>
  <div class="main-event">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">Main Event</div>
      </q-card-section>
      <q-separator />

      <q-card-section class="card-content">
        <q-carousel
          transition-prev="slide-right"
          transition-next="slide-left"
          v-model="slide"
          arrows
          animated
          navigation
          infinite
          :swipeable="true"
          autoplay
        >
          <q-carousel-slide
            v-for="image in getEventImages"
            :key="image.ID"
            :name="image.ID"
            class="column no-wrap flex-center"
            :img-src="image.ImageUrl"
            @click="openEvent(image.Link)"
          />
        </q-carousel>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'MainEvent',
  components: {
  },
  data () {
    return {
      slide: 1
    }
  },
  computed: {
    ...mapGetters({
      getEventImages: 'home/getImageEvent',
      getIsLoading: 'home/getIsLoading'
    })
  },
  mounted () {
    if (this.getEventImages.length) {
      this.slide = this.getEventImages[0].ID
    }
  },
  methods: {
    openEvent (link) {
      window.open(link, '_blank')
    }
  }
}
</script>
<style lang="scss">
.main-event {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      img {
        width: 100%;
        height: 90%;
      }
    }
  }
}
</style>